// extracted by mini-css-extract-plugin
module.exports = {"Property":"nft-properties_Property__oXXcq"};